import type { BestPracticeDescriptionCard, Options } from './types'

export const stepOptions: Options = [{ value: '完善账号信息' }, { value: '创建第一个空间' }, { value: '进入空间' }]
